import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Quality Control',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Quality Control',
        href: '/opc/pti/quality-control',
        active: true,
      },
    ],
    title_form: 'PTI - Form Quality Control',
    items: [],
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_qc_pti',
    sortDesc: true,
    fields: [
      {
        key: 'code_qc_pti',
        label: 'Quality No',
        sortable: true,
      },
      {
        key: 'tgl_qc_pti',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'begin_repair',
        label: 'Begin',
        sortable: true,
      },
      {
        key: 'complete_repair',
        label: 'Complete',
        sortable: true,
      },
      {
        key: 'complete_repair',
        label: 'Complete',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      id_wo_detail: '',
      id_container: '',
      container: '',
      size: '',
      type: '',
      code_wo: '',
      tgl_wo: '',
      begin_repair: '',
      complete_repair: '',
      remark_qc: '',
      damages: [],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeQCPti(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetFormQC() {
    state.data = Object.assign({}, state.data, {
      form: {
        id_wo_detail: '',
        id_container: '',
        container: '',
        size: '',
        type: '',
        code_wo: '',
        tgl_wo: '',
        begin_repair: '',
        complete_repair: '',
        remark_qc: '',
        damages: [],
      },
      search: '',
    });
  },
};

export const actions = {
  async getListQualityControl({ commit, state }) {
    commit('changeQCPti', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/pti-quality-control`, params);
    commit('changeQCPti', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailContainerWO({ commit }, payload = null) {
    commit('changeQCPti', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/pti-quality-control/container-wo/${payload.id}`
    );
    commit('changeQCPti', {
      loading: false,
    });

    if (!result.error) {
      commit('changeQCPti', {
        form: {
          ...result.data.object,
        },
      });
    }

    return !result.error ? true : false;
  },

  async uploadImage({ commit }, payload) {
    commit('changeQCPti', {
      loading: true,
    });

    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeQCPti', {
      loading: false,
    });

    if (!result.error) {
      return result.data.object || false;
    }
  },

  async searchContWO({ commit, state }) {
    commit('changeQCPti', {
      loading: true,
    });

    const { data } = state;
    let params = {
      container: data.form.container || '',
    };

    let result = await ApiGetRequest(`opr/pti-quality-control/search`, params);
    commit('changeQCPti', {
      loading: false,
    });

    if (!result.error) {
      commit('changeQCPti', {
        form: {
          ...result.data.object,
        },
      });
    }

    return !result.error ? true : false;
  },

  async getDetailQC({ commit }, payload = null) {
    commit('changeQCPti', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/pti-quality-control/${payload.id}`);
    commit('changeQCPti', {
      loading: false,
    });

    if (!result.error) {
      commit('changeQCPti', {
        form: {
          ...result.data.object,
        },
      });
    }

    return !result.error ? true : false;
  },

  async createQC({ commit, state, dispatch }, payload = null) {
    commit('changeQCPti', {
      loading: true,
    });

    const { data } = state;
    if (payload && payload.type) {
      data.form['result_check'] = payload.type;
    }
    let result = await ApiPostRequest(`opr/pti-quality-control`, data.form);
    commit('changeQCPti', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateQC({ commit, state, dispatch }, payload = null) {
    commit('changeQCPti', {
      loading: true,
    });

    const { data } = state;
    if (payload && payload.type) {
      data.form['result_check'] = payload.type;
    }
    let result = await ApiPutRequest(
      `opr/pti-quality-control/${payload.id}`,
      data.form
    );
    commit('changeQCPti', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteQC({ commit, dispatch }, payload = null) {
    commit('changeQCPti', {
      loading: true,
    });

    let result = await ApiDeleteRequest(
      `opr/pti-quality-control/${payload.id}`
    );
    commit('changeQCPti', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
